import app from '@/app';
import templateHtml from '!!raw-loader!./kartado-api-button.html';


/* @ngInject */
function KartadoApiButtonController(DialogService, $translate, $http, $state) {
  const $ctrl = this;
  $ctrl.loading = false;

  $ctrl.confirm = (message) => {
    if ($ctrl.loading) {
      return;
    }

    DialogService.confirmSyncApiKartado(message).then(function (result) {
      if (result !== true) {
        return;
      }

      $ctrl.loading = true;

      $http
        .get('api/metadata/kartado/sync', { transformResponse: [function(data) { return data; }] })
        .then(function (response) {
          // Success Path (HTTP 200)
          // The endpoint returns a simple string message
          DialogService.alertMessage(response.data);
        })
        .catch(function (error) {
          // Error Path (HTTP 4xx, 5xx)
          // Extracts error message from backend or use a generic fallback
          const errorMessage = error.data && error.data.message
            ? error.data.message
            : $translate.instant('apiKartadoSync.error.generic');

          const errorList = [[errorMessage]];

          DialogService.alertMessageListError(0, errorList[0]);

          console.error('Sync failed:', error);
        })
        .finally(function () {
          $ctrl.loading = false;
          // Refresh the state to show new synced data
          $state.go('asBuilt', {}, { reload: true });
        });
    });
  };
}




// ensure template is registered in $templateCache at module run time to avoid $templateRequest race
app.component('prKartadoApiButton', {
  template: templateHtml,
  controller: KartadoApiButtonController,
  bindings: {
    type: '@',
    named: '<',
    count: '<',
    state: '@',
    params: '<',
    readonly: '<',
    onClick: '&',
    message: '@'
  }
});
